module.exports = __webpack_public_path__ + "img/余额.c740c615.png";